import jQuery from "jquery";
import "@/assets/js/custom2";
import "@/assets/css/bootstrap.css";
import "@/assets/css/custom.css";

import {createApp} from "vue";

window.jQuery = window.$ = jQuery


import App from "./App.vue";

createApp(App).mount('#app')